/*
 * Copyright (c) 2020, Matthew T. Kaufman
 */

import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Decode from './views/Decode.vue'
import Activity from './views/Activity.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/c/:channel/decode',
            name: 'decode',
            component: Decode
        },
        {
            path: '/c/:channel/activity',
            name: 'activity',
            component: Activity
        }
    ]
})
